import React from 'react'
import PropTypes from 'prop-types'
import Text from './text'

class SidebarSectionTitle extends React.PureComponent {

  render() {
    const { children } = this.props

    return (
      <div className={[_s.d, _s.pt5, _s.pb10, _s.pl5, _s.mt5].join(' ')}>
        <Text color='tertiary' weight='medium' size=''>
          {children}
        </Text>
      </div>
    )
  }

}

SidebarSectionTitle.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SidebarSectionTitle